import { __extends } from "tslib";
import { BaseSelectFoundation } from '../core/base-select-foundation';
import { SELECT_DROPDOWN_CONSTANTS } from './select-dropdown-constants';
var SelectDropdownFoundation = /** @class */ (function (_super) {
    __extends(SelectDropdownFoundation, _super);
    function SelectDropdownFoundation(adapter) {
        var _this = _super.call(this, adapter) || this;
        _this._syncSelectedText = false;
        _this._originalTargetText = '';
        _this._targetDisconnectedListener = function () { return _this._onTargetDisconnected(); };
        return _this;
    }
    SelectDropdownFoundation.prototype.initialize = function () {
        this._tryAttach();
        _super.prototype.initialize.call(this);
    };
    SelectDropdownFoundation.prototype.disconnect = function () {
        _super.prototype.disconnect.call(this);
        if (this._adapter.isAttached()) {
            this._detach();
        }
    };
    SelectDropdownFoundation.prototype._onDropdownScrollEnd = function () {
        this._adapter.emitHostEvent(SELECT_DROPDOWN_CONSTANTS.events.SCROLLED_BOTTOM);
    };
    SelectDropdownFoundation.prototype._applyValue = function (value) {
        _super.prototype._applyValue.call(this, value);
        this.applySelection();
    };
    SelectDropdownFoundation.prototype.applySelection = function () {
        _super.prototype.applySelection.call(this);
        if (this._syncSelectedText || typeof this._selectedTextBuilder === 'function') {
            var text = this._getSelectedText();
            if (!text) {
                text = this._originalTargetText;
            }
            this._adapter.setTargetText(text || '', this._selectedTextTarget);
        }
    };
    SelectDropdownFoundation.prototype._tryAttach = function () {
        this._adapter.attach(this._target);
        if (this._adapter.isAttached()) {
            this._targetDisconnectedDestructor = this._adapter.setTargetDisconnectedListener(this._targetDisconnectedListener);
            this._originalTargetText = this._adapter.getTargetText(this._selectedTextTarget);
            this.initializeTarget();
        }
    };
    SelectDropdownFoundation.prototype._detach = function () {
        this._adapter.detach();
        if (this._targetDisconnectedDestructor) {
            this._targetDisconnectedDestructor();
            this._targetDisconnectedDestructor = undefined;
        }
    };
    SelectDropdownFoundation.prototype._onTargetDisconnected = function () {
        this._adapter.detach();
    };
    Object.defineProperty(SelectDropdownFoundation.prototype, "target", {
        get: function () {
            return this._target;
        },
        set: function (value) {
            if (this._target !== value) {
                this._target = value;
                if (this._adapter.isAttached()) {
                    this._detach();
                }
                this._tryAttach();
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SelectDropdownFoundation.prototype, "selectedTextTarget", {
        get: function () {
            return this._selectedTextTarget;
        },
        set: function (value) {
            if (this._selectedTextTarget !== value) {
                this._selectedTextTarget = value;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SelectDropdownFoundation.prototype, "syncSelectedText", {
        get: function () {
            return this._syncSelectedText;
        },
        set: function (value) {
            if (this._syncSelectedText !== value) {
                this._syncSelectedText = value;
            }
        },
        enumerable: true,
        configurable: true
    });
    return SelectDropdownFoundation;
}(BaseSelectFoundation));
export { SelectDropdownFoundation };
